export default "__VITE_ASSET__vAWG3zwp__"